<template>
  <form :action="formAction" method="post" class="ec-bike-selector">

    <input type="hidden" name="_token" v-bind:value="csrfToken">

    <div class="row">
      <div class="col-xs-12">
        <h3><span class="badge">1</span> Type de cadre</h3>
      </div>
    </div>

    <div class="row ec-bike-selector-frame-type">
      <div class="col-xs-3" v-for="frameType in availableFrameTypes">
        <div class="checkbox ec-bike-selector-frame-type-checkbox">
          <label>
            <div>
              <i class="ec-icon" :class="`ec-icon-frame-type-${frameType.id}`"></i>
            </div>
            <div>
              <input type="checkbox" :name="`frameType${frameType.id}`" v-model="frameTypes[frameType.id]"
                     @change="updateCheckbox">
              {{frameType.name}}
            </div>
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-6">
        <h3><span class="badge">2</span> Votre budget</h3>

        <select2 name="budget"
                 class="form-control"
                 placeholder="illimité"
                 :allow-clear="true"
                 @change="updateBudget"
                 :initial-value="budget"
                 ref="budget">
          <option value="1500">moins de Chf 1500.-</option>
          <option value="2000">moins de Chf 2000.-</option>
          <option value="2500">moins de Chf 2500.-</option>
          <option value="3000">moins de Chf 3000.-</option>
          <option value="4000">moins de Chf 4000.-</option>
          <option value="5000">moins de Chf 5000.-</option>
          <option value="6000">moins de Chf 6000.-</option>
        </select2>
      </div>

      <div class="col-xs-12 col-md-6">
        <h3><span class="badge">3</span> Vos utilisations</h3>

        <div class="checkbox">
          <label>
            <input type="checkbox" name="usageWork" v-model="usageWork" @change="updateCheckbox">
            Travail
          </label>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" name="usageFamily" v-model="usageFamily" @change="updateCheckbox">
            Famille
          </label>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" name="usageRiding" v-model="usageRiding" @change="updateCheckbox">
            Promenade
          </label>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" name="usageSport" v-model="usageSport" @change="updateCheckbox">
            Sport - Route
          </label>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" name="usageMountain" v-model="usageMountain"
                   @change="updateCheckbox">
            Sport - Tout Terrain
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-6">
        <h3><span class="badge">4</span> Sur quel type de chemin</h3>

        <select2 name="terrain"
                 class="form-control"
                 placeholder="tous les types de chemin"
                 :allow-clear="true"
                 @change="updateTerrain"
                 :initial-value="terrain"
                 ref="terrain">
          <option value="1">Route goudronnée</option>
          <option value="2">Polyvalent</option>
          <option value="3">Tout terrain</option>
        </select2>

      </div>

      <div class="col-xs-12 col-md-6">
        <h3><span class="badge">5</span> Dénivelés</h3>

        <div class="checkbox">
          <label>
            <input type="checkbox" name="steepSlopes" v-model="steepSlopes" @change="updateCheckbox">
            Pentes Raides (Ex : Haut de Lausanne, Haut de Montreux...)
          </label>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" name="lowSlopes" v-model="lowSlopes" @change="updateCheckbox">
            Pentes Douces (Ex : Genève, Vevey, Martigny...)
          </label>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-xs-12 col-md-6">
        <h3><span class="badge">6</span> La distance de vos sorties</h3>

        <select2 name="autonomy"
                 class="form-control"
                 placeholder="toutes les distances"
                 :allow-clear="true"
                 @change="updateAutonomy"
                 :initial-value="autonomy"
                 ref="autonomy">
          <option value="0-40">Inférieure à 40km</option>
          <option value="40-80">Entre 40 et 80 km</option>
          <option value="80-Infinity">Plus de 80km</option>
        </select2>
      </div>

      <div class="col-xs-12 col-md-6">
        <h3><span class="badge">7</span> Vitesse de pointe</h3>

        <select2 name="maxSupportedSpeed"
                 class="form-control"
                 placeholder="toutes les vitesses"
                 :allow-clear="true"
                 @change="updateMaxSupportedSpeed"
                 :initial-value="maxSupportedSpeed"
                 ref="maxSupportedSpeed">
          <option value="25">Assistance jusqu'à 25 km/h</option>
          <option value="45">Assistance jusqu'à 45 km/h</option>
        </select2>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-6">
        <h3><span class="badge">8</span> Vos souhaits spéciaux</h3>

        <div class="checkbox">
          <label>
            <input type="checkbox" name="specialFolding" v-model="specialFolding" @change="updateCheckbox">
            Pliable
          </label>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" name="specialFamily" v-model="specialFamily" @change="updateCheckbox">
            Famille / Cargo
          </label>
        </div>
      </div>

    </div>

    <div class="ec-bike-selector-controls col-xs-12">
                <span class="ec-bike-selector-results">
                    <span v-if="loadingResults"><i class="fa fa-spinner fa-spin"></i></span>
                    <span v-if="!loadingResults">{{totalResults}}</span> résultats
                </span>

      <a href="#"
         class="btn btn-primary-inverse"
         :class="{disabled: !totalResults}"
         @click="applyFilters()">Voir les vélos</a>
      <a href="#"
         class="btn btn-primary-inverse"
         :class="{disabled: !filtersChanged}"
         @click="resetFilters()">Réinitialiser<span class="visible-sm"> les filtres</span></a>
    </div>

  </form>
</template>

<style lang="scss" type="text/scss">
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  $form-padding: 60px;

  .ec-bike-selector {

    .ec-bike-selector-controls {
      text-align: center;
      background: $ec-primary-color;
      padding: $grid-gutter-width;
      margin-top: $grid-gutter-width * 2;

      .ec-bike-selector-results {
        font-size: $ec-font-size-h3;
        color: $ec-color-white;
        margin-right: $grid-gutter-width/2;
        display: inline-block;
        top: 3px;
        position: relative;
      }

      .btn {
        display: inline-block;
        margin-right: $grid-gutter-width/2;
      }

      @media (min-width: $screen-sm-min) {
        span.visible-sm {
          display: inline-block !important;
        }
      }
    }

    .ec-bike-selector-frame-type-checkbox {
      label {
        text-align: center;

        .ec-icon {
          display: block;
          font-size: $ec-font-size-h1 * 2;
          color: $ec-primary-color;
          margin-bottom: $grid-gutter-width/2;
          margin-left: -$grid-gutter-width/2;

          @media(max-width: $screen-sm-max) and (min-width: $screen-sm-min) {
            font-size: $ec-font-size-h1 * 1.5;
          }

          @media(max-width: $screen-xs-max) and (min-width: $screen-xs-min) {
            font-size: $ec-font-size-h1 * 1.2;
          }

          @media(max-width: $screen-tn-max) {
            font-size: $ec-font-size-h1;
          }
        }
      }
    }

    .row {
      &:first-child {
        h3 {
          margin-top: $grid-gutter-width;
        }
      }

      > div {
        padding-left: $form-padding;
        padding-right: $grid-gutter-width;
      }

      &.ec-bike-selector-frame-type {
        width: 100%;
        margin: 0;
        overflow-x: hidden;

        > div {
          padding-right: 0;
          padding-left: 0;

          .checkbox label {
            padding-left: 0;
          }

          &:first-child {
            margin-left: $grid-gutter-width*2;
          }

          &:last-child {
            margin-right: -$grid-gutter-width*2;
          }
        }
      }
    }

    h3 {
      margin: $grid-gutter-width * 2 0 $grid-gutter-width 0;
      color: $ec-primary-color;
      position: relative;

      .badge {
        color: $ec-color-white;
        background: $ec-primary-color;
        padding: $grid-gutter-width/3 $grid-gutter-width/3 ($grid-gutter-width/3 - 2px) $grid-gutter-width/3;
        font-size: $ec-font-size-h4;
        margin-right: $grid-gutter-width/3;
        width: 1.75em;
        height: 1.75em;
        position: absolute;
        left: -$form-padding + $grid-gutter-width/2;
        top: -4px;

        @include ec-flex-center();
        @include border-radius($ec-font-size-h3);

        display: inline-flex;
      }
    }
  }

</style>

<script type="text/babel">
  export default {
    props: ['availableFrameTypes', 'formAction', 'filterEndpoint', 'initialTotalResults', 'initialValues'],

    data: function () {
      let frameTypes = {};

      for (let i in this.availableFrameTypes) {
        let frameType = this.availableFrameTypes[i];
        frameTypes[frameType.id] = false;
      }

      return {
        totalResults: 0,
        budget: null,
        autonomy: null,
        maxSupportedSpeed: null,
        terrain: null,
        loadingResults: false,
        frameTypes: frameTypes,
        usageWork: false,
        usageFamily: false,
        usageRiding: false,
        usageSport: false,
        usageMountain: false,
        steepSlopes: false,
        lowSlopes: false,
        specialFolding: false,
        specialFamily: false,
        xhr: null,
        csrfToken: ''
      };
    },

    mounted: function () {
      this.resetTotalResults();
      this.initValues();

      this.csrfToken = $('meta[name="csrf-token"]').attr('content');
    },

    computed: {
      filtersChanged: function () {
        let frameTypesChanged = false;

        for (let i in this.frameTypes) {
          if (this.frameTypes[i]) {
            frameTypesChanged = true;
            break;
          }
        }

        return frameTypesChanged ||
          this.usageWork ||
          this.usageFamily ||
          this.usageRiding ||
          this.usageSport ||
          this.usageMountain ||
          this.steepSlopes ||
          this.lowSlopes ||
          this.specialFolding ||
          this.specialFamily ||
          this.budget ||
          this.terrain ||
          this.autonomy ||
          this.maxSupportedSpeed;
      }
    },

    methods: {
      updateBudget: function (value) {
        this.budget = value;
        this.loadResults();
      },

      updateAutonomy: function (value) {
        this.autonomy = value;
        this.loadResults();
      },

      updateMaxSupportedSpeed: function (value) {
        this.maxSupportedSpeed = value;
        this.loadResults();
      },

      updateTerrain: function (value) {
        this.terrain = value;
        this.loadResults();
      },

      updateCheckbox: function () {
        this.loadResults();
      },

      resetTotalResults: function () {
        this.totalResults = this.initialTotalResults;
      },

      initValues: function () {
        let values = this.initialValues;

        if (!values) {
          return;
        }

        for (let i in this.availableFrameTypes) {
          let frameType = this.availableFrameTypes[i];

          this.frameTypes[frameType.id] = !!values['frameType' + frameType.id] || false;
        }

        this.budget = values.budget || null;
        this.autonomy = values.autonomy || null;
        this.maxSupportedSpeed = values.maxSupportedSpeed || null;
        this.terrain = values.terrain || null;
        this.usageWork = !!values.usageWork || false;
        this.usageFamily = !!values.usageFamily || false;
        this.usageRiding = !!values.usageRiding || false;
        this.usageSport = !!values.usageSport || false;
        this.usageMountain = !!values.usageMountain || false;
        this.steepSlopes = !!values.steepSlopes || false;
        this.lowSlopes = !!values.lowSlopes || false;
        this.specialFolding = !!values.specialFolding || false;
        this.specialFamily = !!values.specialFamily || false;

        this.$nextTick(function () {
          this.$refs.maxSupportedSpeed.reset();
          this.$refs.budget.reset();
          this.$refs.autonomy.reset();
          this.$refs.terrain.reset();

          this.loadResults();
        });
        //
      },

      loadResults: function () {
        try {
          this.xhr.abort();
        } catch (e) {
        }

        if (!this.filtersChanged) {
          this.resetTotalResults();
          return;
        }

        this.loadingResults = true;

        let payload = {
          budget: this.budget || null,
          autonomy: this.autonomy || null,
          maxSupportedSpeed: this.maxSupportedSpeed || null,
          terrain: this.terrain || null,
          usageWork: this.usageWork || null,
          usageFamily: this.usageFamily || null,
          usageRiding: this.usageRiding || null,
          usageSport: this.usageSport || null,
          usageMountain: this.usageMountain || null,
          steepSlopes: this.steepSlopes || null,
          lowSlopes: this.lowSlopes || null,
          specialFolding: this.specialFolding || null,
          specialFamily: this.specialFamily || null
        };

        for (let i in this.availableFrameTypes) {
          let frameType = this.availableFrameTypes[i];

          payload['frameType' + frameType.id] = this.frameTypes[frameType.id] || null;
        }

        let that = this;

        this.xhr = $.ajax({
          url: this.filterEndpoint,
          method: 'get',
          data: payload,
          success: function (data) {
            if (data.success) {
              that.totalResults = data.count;
            }
            else {
              console.error('Wrong payload produced server error:', payload, data);
              bootbox.alert('Le serveur a retourné une erreur. Veuillez essayer plus tard.');
            }
          },
          error: function (data) {
            if (data && data.status === 0 && data.statusText === 'abort') {
              return;
            }

            bootbox.alert('Le serveur a retourné une erreur. Veuillez essayer plus tard.');
          },
          complete: function () {
            that.loadingResults = false;
          }
        });
      },

      applyFilters: function () {
        this.$el.submit();
      },

      resetFilters: function () {
        // clear all models
        for (let i in this.frameTypes) {
          this.frameTypes[i] = false;
        }

        this.budget = null;
        this.autonomy = null;
        this.maxSupportedSpeed = null;
        this.terrain = null;
        this.usageWork = false;
        this.usageFamily = false;
        this.usageRiding = false;
        this.usageSport = false;
        this.usageMountain = false;
        this.steepSlopes = false;
        this.lowSlopes = false;
        this.specialFolding = false;
        this.specialFamily = false;

        // select2
        this.$refs.maxSupportedSpeed.clear();
        this.$refs.budget.clear();
        this.$refs.autonomy.clear();
        this.$refs.terrain.clear();
      }
    }
  };
</script>
